var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import JsonExportButton from '~/js/components/atomos/JsonExportButton.vue';
var LiveStreams = /** @class */ (function (_super) {
    __extends(LiveStreams, _super);
    function LiveStreams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.json = null;
        _this.result = [];
        return _this;
    }
    Object.defineProperty(LiveStreams.prototype, "status", {
        get: function () {
            if (this.json == null)
                return 'in progress';
            if (this.json.result === undefined)
                return 'forbidden';
            return 'success';
        },
        enumerable: false,
        configurable: true
    });
    LiveStreams.prototype.created = function () {
        var _this = this;
        // https://developers.google.com/youtube/v3/live/docs/liveStreams/list
        gapi.client.load('youtube', 'v3', function () {
            var options = {
                part: 'snippet,id,status,cdn',
                mine: true,
                maxResult: 20
            };
            var request = gapi.client.youtube.liveStreams.list(options);
            request.execute(function (response) {
                console.log('==== Live Streams ====');
                console.log(response);
                console.log('==== /Live Streams ====');
                _this.json = {
                    request: 'gapi.client.youtube.liveStreams.list',
                    options: options,
                    result: response.result
                };
                _this.result = response.result != null ? response.result.items || [] : [];
            });
        });
    };
    LiveStreams = __decorate([
        Component({
            components: { JsonExportButton: JsonExportButton }
        })
    ], LiveStreams);
    return LiveStreams;
}(Vue));
export default LiveStreams;
